import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { MdOutlineCancel } from "react-icons/md";
import { getlinks } from "../data/dummy";
import logo from "../data/Mask group (2).svg";
import { useStateContext } from "../contexts/ContextProvider";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";

const Sidebar = ({ currentUser }) => {
  const { currentColor, activeMenu, setActiveMenu, screenSize } = useStateContext();
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownClick = (name) => {
    setOpenDropdown((prev) => (prev === name ? null : name));
  };

  const handleCloseSideBar = () => {
    if (activeMenu !== undefined && screenSize <= 900) {
      setActiveMenu(false);
    }
  };

  const cleanString = (input) => input.replace(/[_\W]+/g, " ").trim();

  const activeLink = `
    flex items-center gap-4 px-4 py-3 mt-1
    rounded-xl text-white font-medium
    transition-all duration-300 ease-in-out
    hover:bg-[var(--active-bg,#2563eb)]
    shadow-sm hover:shadow-md
    transform hover:translate-x-1
  `;

  const normalLink = `
    flex items-center gap-4 px-4 py-2 mt-1
    rounded-xl text-gray-700 dark:text-gray-200
    hover:bg-gray-50 dark:hover:bg-gray-800
    transition-all duration-300 ease-in-out
    hover:shadow-sm transform hover:translate-x-1
  `;

  return (
    <div className="ml-3 mt-3 h-screen overflow-y-auto pr-3 pb-2 custom-scrollbar">
      {activeMenu && (
        <>
          <div className="flex justify-between items-center mt-5 mb-5">
            <Link
              to="/"
              onClick={handleCloseSideBar}
              className="flex items-center w-full justify-center text-md font-extrabold tracking-tight dark:text-white text-slate-900 transition-transform hover:scale-105"
            >
              <div className="flex justify-center items-center gap-4">
                <img src={logo} alt="logo" className="w-8 h-8 object-contain" />
                <span className="text-2xl font-bold whitespace-nowrap bg-gradient-to-r from-blue-600 to-purple-600 text-transparent-black bg-clip-text">
                  Mohtaj
                </span>
              </div>
            </Link>

            <button
              type="button"
              title="Menu"
              onClick={() => setActiveMenu(!activeMenu)}
              style={{ color: currentColor }}
              className="text-xl rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 block md:hidden"
            >
              <MdOutlineCancel />
            </button>
          </div>

          <div className="mt-2">
            {getlinks(currentUser?.role, currentUser?.status).map((item) => (
              <div key={item.title} className="mb-6">
                <p className="text-gray-500 dark:text-gray-400 uppercase text-xs font-bold mb-3 px-4 tracking-wider">
                  {item.title}
                </p>

                {item.links.map((link) => (
                  <div key={link.name} className="mb-1">
                    {!link.children ? (
                      <NavLink
                        to={`/${link.name}`}
                        onClick={handleCloseSideBar}
                        style={({ isActive }) => ({
                          backgroundColor: isActive ? currentColor : "",
                          '--active-bg': currentColor,
                        })}
                        className={({ isActive }) => (isActive ? activeLink : normalLink)}
                      >
                        <span className="text-xl">{link.icon}</span>
                        <span className="capitalize font-medium">{link.title || link.name}</span>
                      </NavLink>
                    ) : (
                      <>
                        <div
                          onClick={() => handleDropdownClick(link.name)}
                          className="flex items-center justify-between px-4 py-3 mt-1 cursor-pointer
                            text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-800
                            rounded-xl transition-all duration-300 ease-in-out group"
                        >
                          <div className="flex items-center gap-4">
                            <span className="text-xl">{link.icon}</span>
                            <span className="capitalize font-medium">{link.title || link.name}</span>
                          </div>
                          <span className="text-sm transition-transform duration-300">
                            {openDropdown === link.name ? (
                              <IoIosArrowDown className="transform rotate-0" />
                            ) : (
                              <IoIosArrowUp className="transform rotate-180" />
                            )}
                          </span>
                        </div>

                        {openDropdown === link.name && (
                          <div className="border-l-2 border-gray-200 dark:border-gray-700 ml-6 mt-1 transition-all duration-300">
                            {link.children.map((child) => (
                              <NavLink
                                key={child.name}
                                to={`/${child.name}`}
                                onClick={handleCloseSideBar}
                                style={({ isActive }) => ({
                                  backgroundColor: isActive ? currentColor : "",
                                  '--active-bg': currentColor,
                                })}
                                className={({ isActive }) => (isActive ? activeLink : normalLink)}
                              >
                                <span className="text-xl">{child.icon}</span>
                                <span className="capitalize font-medium">{cleanString(child.title)}</span>
                              </NavLink>
                            ))}
                          </div>
                        )}
                      </>
                    )}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default Sidebar;
